import dayjs from "dayjs";
import {Box, Stack, Typography} from "@mui/material";
import {IrrigationPlannerDataProps} from "../../types/irrigationPlannerDataProps";
import {useTranslation} from "react-i18next";
import {useMeasureSystemUtils} from "../../hooks/measureSystemUtilsHooks";
import {HelpPopover} from "../base/HelpPopover";
import {TFunction} from "i18next";

export const FieldAdvisedIrrigationCard: React.FC<{data: IrrigationPlannerDataProps[]}> = ({data}) => {
    const {t, i18n} = useTranslation();
    const daysOffset = data.findIndex((item) => item.irrigationForecast > 0);
    const msUtils = useMeasureSystemUtils();

    return (
        <Stack
            direction="column"
            alignItems="center"
            bgcolor="#F3F5FA"
            padding="1.5rem"
            border={1}
            borderColor="#E9EBF1 !important"
            minWidth="15rem"
            gap="1.25rem"
            position="relative"
        >
            <Typography textTransform="uppercase" fontSize={16} fontWeight={500} paddingX="1.5rem">
                {t("insights.field_advised_irrigation.title")}
            </Typography>
            <Stack direction="column" alignItems="center" gap="0.25rem" width="100%" flex="1">
                <Stack bgcolor="#FAFCFF" width="100%" textAlign="center" justifyContent="center" height="4.2rem">
                    <Typography textTransform="uppercase" fontSize={24} fontWeight={700} color="primary">
                        {daysOffset >= 0 && getAdvisedDayLabel(daysOffset, data[0].date, t, i18n)}
                    </Typography>
                </Stack>
                <Stack bgcolor="#FAFCFF" width="100%" textAlign="center" justifyContent="center" flex={1}>
                    <Typography fontSize={36} fontWeight={700}>
                        {daysOffset >= 0 &&
                            data[daysOffset].irrigationForecast > 0 &&
                            `${Number(data[daysOffset].irrigationForecast).toFixed(1)} ${msUtils.getRainfallUnits()}`}
                    </Typography>
                </Stack>
            </Stack>

            <Box sx={{position: "absolute", right: "0", top: "0"}}>
                <HelpPopover i18nKey="help.popover.fields.next_advised_irrigation" placement="top" direction="right" />
            </Box>
        </Stack>
    );
};

const getAdvisedDayLabel = (
    daysOffset: number,
    firstDayDate: Date | undefined,
    t: TFunction,
    i18n: {language: string},
): string => {
    if (daysOffset < 0 || !firstDayDate) {
        return "-";
    }

    const today = dayjs();
    const irrigationDay = dayjs(firstDayDate).add(daysOffset, "days");

    if (irrigationDay.isSame(today)) {
        return t("insights_page.irrigation_advice.today");
    } else if (irrigationDay.isSame(today.add(1, "day"), "day")) {
        return t("insights_page.irrigation_advice.tomorrow");
    } else {
        return irrigationDay.locale(i18n.language).format("ddd, MMM DD");
    }
};
